import { actions } from "./Reducer";

/**
 * Actions that fire saga watchers
 */
export const getSupplierProductAction = (id) => ({
  type : actions.GET_SUPPLIER_PRODUCT,
  payload : id
})

export const getSupplierProductsAction = (body) => ({
  type: actions.GET_SUPPLIER_PRODUCTS,
  payload: body,
});

export const createSupplierProductAction = (formData) => ({
  type: actions.CREATE_SUPPLIER_PRODUCT,
  payload: formData,
});

export const updateSupplierProductAction = (id, formData) => ({
  type: actions.UPDATE_SUPPLIER_PRODUCT,
  payload: {
    formData,
    id,
  },
});

export const getSupplierProductsPictures = () => ({
  type: actions.GET_SUPPLIER_PRODUCTS_PICTURES,
})

export const addEditorReivewSupplierProduct = (id,formData) => ({
  type: actions.ADD_EDITOR_REVIEW_SUPPIER_PRODUCT,
  payload : {
    formData,
    id,
  }
})
/**
 * Actions that are fired by redux-saga watchers
 */

export const getSupplierProductSuccessAction = (product) => ({
  type : actions.GET_SUPPLIER_PRODUCT_SUCCESS,
  payload : product
})

export const getSupplierProductsSuccessAction = (products) => ({
  type: actions.GET_SUPPLIER_PRODUCTS_SUCCESS,
  payload: products,
});

export const createSupplierProductSuccessAction = (product) => ({
  type: actions.CREATE_SUPPLIER_PRODUCT_SUCCESS,
  payload: product,
});

export const updateSupplierProductSuccessAction = (product) => ({
  type: actions.UPDATE_SUPPLIER_PRODUCT_SUCCESS,
  payload: product,
});

export const getSupplierProductPicturesSuccess = (productsPictures) => ({
  type: actions.GET_SUPPLIER_PRODUCTS_PICTURES_SUCCESS,
  payload: productsPictures 
})

/**
 * Misc
 */

export const setSupplierProductsIsLoadingAction = (payload) => ({
  type: actions.SET_SUPPLIER_PRODUCTS_IS_LOADING,
  payload,
});

export const setSupplierProductsCountAction = (count) => ({
  type: actions.SET_SUPPLIER_PRODUCTS_COUNT,
  payload: count,
});

export const setSearchValueAction = (value) => ({
  type: actions.SET_SP_SEARCH_VALUE,
  payload: value,
});
